import { ACTION, RequestCopyRiskEvaluation, ReceiveCopyRiskEvaluation } from './action-types';
import { ActionMap } from 'app/area/case/types';
import { CaseState } from 'app/area/case/types-store';

export const reducers: ActionMap = {

  [ACTION.REQUEST_COPY_RISK_EVALUATION]: (state: CaseState, action: RequestCopyRiskEvaluation): CaseState => {
    return {
      ...state,
      ...{
        copyingRiskEvaluation: true
      }
    };
  },
  
  [ACTION.RECEIVE_COPY_RISK_EVALUATION]: (state: CaseState, action: ReceiveCopyRiskEvaluation): CaseState => {
    return {
      ...state,
      ...{
        copyingRiskEvaluation: false
      }
    };
  }
};
